import React, { useState } from "react";
import { Button, Modal, Container, Row, Col, Alert } from "react-bootstrap";
import Form from "react-bootstrap/Form";

function EditModal({ cliente, updateCliente, setBusqueda }) {
  // States del Modal
  const [show, setShow] = useState(false);
  const [error, setError] = useState(false);
  // clean state
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  // States de los campos del form.
  const [nombre, setNombre] = useState(cliente.nombre);
  const [apellido, setApellido] = useState(cliente.apellido);
  const [domicilio, setDomicilio] = useState(cliente.domicilio);
  const [telefono, setTelefono] = useState(cliente.telefono);
  const [mail, setMail] = useState(cliente.mail);
  const [largoPelo, setLargoPelo] = useState(cliente.largo_pelo);
  const [detalle, setDetalle] = useState(cliente.info);
  const [cumpleaños, setCumpleaños] = useState(cliente.cumpleaños);

  // Funcion encargada de poner en mayuscula nombre y apellido
  function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  // Funcion encargada de tomar los datos del form y actualizar el cliente en la DB.
  async function handleEdit() {
    // Si el campo cumpleaños esta vacio ponemos por defecto una fecha para no romper el backend.
    const defaultCumple = cumpleaños !== "" ? cumpleaños : "1950-01-01";

    const clienteModificado = {
      apellido: capitalizeFirstLetter(apellido),
      nombre: capitalizeFirstLetter(nombre),
      domicilio: capitalizeFirstLetter(domicilio),
      telefono: telefono,
      mail: mail,
      info: capitalizeFirstLetter(detalle),
      cumpleaños: defaultCumple,
      largo_pelo: largoPelo,
    };

    if (
      clienteModificado.apellido !== "" &&
      clienteModificado.nombre !== "" &&
      clienteModificado.telefono !== "" &&
      clienteModificado.largo_pelo !== ""
    ) {
      updateCliente(cliente.id, clienteModificado);
      handleClose();
    } else {
      setError(true);
    }
  }

  // Funcion encargada de volver a cargar los valores originales en cada input del formulario cuando se cancela el edit.
  const handleCancel = () => {
    setNombre(cliente.nombre);
    setApellido(cliente.apellido);
    setDomicilio(cliente.domicilio);
    setTelefono(cliente.telefono);
    setMail(cliente.mail);
    setLargoPelo(cliente.largo_pelo);
    setDetalle(cliente.info);
    setCumpleaños(cliente.cumpleaños);
    setError(false);

    handleClose();
  };

  return (
    <>
      <Button className="m-1" variant="warning" size="sm" onClick={handleShow}>
        Editar
      </Button>

      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
        size="lg"
        centered
      >
        <Modal.Header closeButton onClick={handleCancel}>
          <Modal.Title>
            Editar Cliente: "{cliente.nombre} {cliente.apellido}"
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="show-grid">
          <Container>
            {error && (

              <Alert variant="danger">
                ¡Debe completar los campos: nombre, apellido, teléfono y largo
                de pelo!
              </Alert>

            )}
            <Row>
              <Col xs={12} md={6}>
                <Form.Group
                  onChange={(e) => {
                    setNombre(e.target.value);
                  }}
                  className="mb-3"
                >
                  <Form.Label>Nombre:</Form.Label>
                  <Form.Control type="text" defaultValue={nombre} />
                </Form.Group>
              </Col>
              <Col xs={12} md={6}>
                <Form.Group
                  onChange={(e) => {
                    setApellido(e.target.value);
                  }}
                  className="mb-3"
                >
                  <Form.Label>Apellido:</Form.Label>
                  <Form.Control type="text" defaultValue={apellido} />
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col xs={12} md={4}>
                <Form.Group
                  onChange={(e) => {
                    setDomicilio(e.target.value);
                  }}
                  className="mb-3"
                >
                  <Form.Label>Domicilio:</Form.Label>
                  <Form.Control type="text" defaultValue={domicilio} />
                </Form.Group>
              </Col>

              <Col xs={12} md={5}>
                <Form.Group
                  onChange={(e) => {
                    setTelefono(e.target.value);
                  }}
                  className="mb-3"
                >
                  <Form.Label>Teléfono:</Form.Label>
                  <Form.Control type="text" defaultValue={telefono} />
                </Form.Group>
              </Col>

              <Col xs={6} md={3}>
                <Form.Group
                  onChange={(e) => {
                    setLargoPelo(e.target.value);
                  }}
                  className="mb-3"
                >
                  <Form.Label>Largo del pelo:</Form.Label>
                  <Form.Select type="text" defaultValue={largoPelo}>
                    <option value={"C"}>C</option>
                    <option value={"M"}>M</option>
                    <option value={"L"}>L</option>
                  </Form.Select>
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col xs={12} md={8}>
                <Form.Group
                  onChange={(e) => {
                    setMail(e.target.value);
                  }}
                  className="mb-3"
                >
                  <Form.Label>Mail:</Form.Label>
                  <Form.Control type="email" defaultValue={mail} />
                </Form.Group>
              </Col>

              <Col xs={12} md={4}>
                <Form.Group
                  onChange={(e) => {
                    setCumpleaños(e.target.value);
                  }}
                  className="mb-3"
                >
                  <Form.Label>Cumpleaños:</Form.Label>
                  <Form.Control type="date" defaultValue={cumpleaños} />
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col xs={12} md={12}>
                <Form.Group
                  onChange={(e) => {
                    setDetalle(e.target.value);
                  }}
                  className="mb-3"
                >
                  <Form.Label>Detalle:</Form.Label>
                  <Form.Control as="textarea" defaultValue={detalle} />
                </Form.Group>
              </Col>
            </Row>
          </Container>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="outline-danger" size="sm" onClick={handleCancel}>
            Cancelar
          </Button>
          <Button
            onClick={() => handleEdit()}
            variant="outline-success"
            size="sm"
          >
            Guardar
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default EditModal;
